module.exports = __webpack_public_path__ + "ac14224cc87b2ee48b3d179d3c12fbd7.png";